{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Je werk wordt alleen tijdelijk opgeslagen",
      "description": "Als gast heb je na het sluiten van dit tabblad geen toegang meer tot je toetsen, chats en bestanden; ze worden uiterlijk 24 uur na je laatste activiteit verwijderd. Meld je gratis aan om ze blijvend op te slaan.",
      "loginButton": "Nu aanmelden"
    },
    "actions": {
      "newExamTitle": "Nieuwe toets maken",
      "creating": "Maken...",
      "newExam": "Nieuwe toets"
    },
    "examList": {
      "title": "Mijn toetsen",
      "noExams": "Geen toetsen gevonden.",
      "unnamed": "Naamloos",
      "unnamedExam": "Naamloze toets",
      "loadOlder": "Oudere toetsen laden"
    },
    "examMenu": {
      "edit": "Bewerken",
      "addToClass": "Aan klas toevoegen",
      "delete": "Verwijderen"
    },
    "bottomNav": {
      "profile": "Profiel",
      "settings": "Instellingen",
      "feedback": "Feedback geven"
    },
    "dialogs": {
      "renameTitle": "Toets bewerken",
      "groupTitle": "Toets groeperen",
      "renameDesc": "Bewerk de informatie van de toets.",
      "groupDesc": "Kies een klas of groep voor deze toets.",
      "fields": {
        "name": "Naam",
        "subject": "Vak",
        "topic": "Onderwerp",
        "class": "Klas",
        "placeholderSelect": "Gelieve te kiezen..."
      },
      "save": "Opslaan"
    },
    "alerts": {
      "saveFailed": "Opslaan mislukt"
    },
    "deleteDialog": {
      "title": "Toets verwijderen?",
      "body": "De toets wordt samen met de chat, alle inzendingen en bestanden definitief verwijderd.",
      "keepReleases": "Aan leerlingen vrijgegeven resultaten behouden",
      "keepReleasesDesc_one": "1 leerling blijft zijn resultaat zien. Zonder vinkje wordt het ook verwijderd.",
      "keepReleasesDesc_other": "{{count}} leerlingen blijven hun resultaten zien. Zonder vinkje worden deze resultaten ook verwijderd.",
      "keepReleasesDescUnknown": "Alle vrijgegeven resultaten blijven zichtbaar voor leerlingen. Zonder vinkje worden ze ook verwijderd.",
      "cancel": "Annuleren",
      "confirm": "Verwijderen"
    }
  },
  "Settings": {
    "title": "Instellingen",
    "soon": "Binnenkort beschikbaar",
    "DisplayAndLanguage": {
      "title": "Weergave & Taal",
      "languageLabel": "Taal",
      "languageDesc": "Kies de taal van de gebruikersinterface.",
      "themeLabel": "Weergave",
      "themeDesc": "Wissel tussen lichte en donkere modus."
    },
    "AI": {
      "title": "AI & Beoordeling",
      "strictnessLabel": "AI-onzekerheid",
      "strictnessDesc": "Bepaalt bij welk AI-vertrouwensniveau handmatige beoordeling verplicht is.",
      "strictnessWarning": "Waarschuwing: Met \"Hoge Autonomie\" grijpt u alleen handmatig in wanneer de AI zeer onzeker is...",
      "gradingKindnessLabel": "Beoordelingsstrengheid",
      "gradingKindnessDesc": "Bepaalt hoe strikt de AI het beoordelingsschema toepast. Mild bevoordeelt de student in grensgevallen; Strikt volgt het schema exact.",
      "gradingKindnessOptions": {
        "lenient": "Mild",
        "balanced": "Gebalanceerd",
        "strict": "Strikt"
      }
    },
    "Notifications": {
      "title": "Meldingen",
      "soon": "Binnenkort beschikbaar",
      "emailLabel": "E-mailmeldingen",
      "emailDesc": "Ontvang e-mailmeldingen over belangrijke gebeurtenissen",
      "browserLabel": "Browsermeldingen",
      "browserDesc": "Pushmeldingen rechtstreeks in je browser ontvangen"
    },
    "About": {
      "title": "Over Gradias",
      "landingPage": "gradias.ai bezoeken",
      "support": "Hulp & Ondersteuning",
      "imprint": "Colofon",
      "privacy": "Privacyverklaring"
    },
    "Account": {
      "title": "Gegevens & Account",
      "exportLabel": "Mijn gegevens exporteren",
      "exportDesc": "Download alle geüploade toetsen en resultaten als ZIP",
      "deleteLabel": "Account verwijderen",
      "deleteDesc": "Je account en je gegevens definitief verwijderen",
      "deleteDialogTitle": "Account verwijderen?",
      "deleteDialogBody": "We sturen je een bevestigingslink naar je e-mailadres. Pas via die link wordt je account verwijderd – samen met je oefentoetsen, chats, bestanden, klaslidmaatschappen en de voor jou vrijgegeven resultaten. Werk dat je bij de toets van een docent hebt ingeleverd, blijft bij de docent.",
      "deleteDialogSent": "We hebben je een link gestuurd. Open hem binnen een uur om het verwijderen te bevestigen.",
      "deleteDialogError": "Er is iets misgegaan. Probeer het later opnieuw.",
      "deleteDialogCancel": "Annuleren",
      "deleteDialogConfirm": "Bevestigingslink sturen",
      "deleteDialogClose": "Sluiten",
      "deleteDialogBodyTeacher": "We sturen je een bevestigingslink naar je e-mailadres. Pas via die link wordt je account verwijderd – met al je klassen, toetsen, inzendingen, chats en bestanden. Je leerlingen verliezen hun klas en alle voor hen vrijgegeven resultaten; hun eigen accounts blijven bestaan. Laat het hen vooraf weten.",
      "deleteDialogImpactTeacher": "Klassen: {{classes}} · Toetsen: {{exams}} · Betrokken leerlingen: {{students}}",
      "deleteDialogBlockedAdmin": "Beheerdersaccounts kunnen hier niet worden verwijderd. Het account moet eerst uit ADMIN_USER_IDS worden gehaald.",
      "deleteDialogBlockedImpersonating": "Dit account kan niet worden verwijderd terwijl je als een andere gebruiker bent aangemeld."
    }
  },
  "Profile": {
    "title": "Profiel",
    "actions": {
      "cancel": "Annuleren",
      "save": "Opslaan",
      "edit": "Bewerken"
    },
    "alerts": {
      "saveError": "Profiel kon niet worden opgeslagen.",
      "generalError": "Er is een fout opgetreden."
    },
    "personal": {
      "firstName": "Voornaam",
      "lastName": "Achternaam",
      "name": "Naam",
      "school": "School",
      "noSchool": "Geen school opgegeven",
      "email": "E-mail",
      "emailHint": "E-mailadres kan hier niet worden gewijzigd.",
      "defaultUser": "Gebruiker",
      "role": {
        "teacher": "Docent",
        "student": "Leerling"
      }
    },
    "teaching": {
      "subjects": "Mijn vakken",
      "noSubjects": "Geen vakken opgegeven"
    },
    "rules": {
      "title": "Regels & Voorkeuren",
      "description": "Opgeslagen voorkeuren waar de assistent zich aan houdt – bij het chatten, beoordelen en bij het maken van modeloplossingen en beoordelingsschema's. Je kunt ze hier zelf bewerken, maar de assistent past ze op verzoek ook rechtstreeks in de chat voor je aan.",
      "general": "Algemeen",
      "empty": "Nog geen regels opgeslagen.",
      "addRule": "Regel toevoegen",
      "removeRule": "Regel verwijderen",
      "limitReached": "Maximum bereikt",
      "limitHint": "Maximaal {{max}} regels per categorie",
      "placeholder": "Regel beschrijven...",
      "categories": {
        "chat_and_workflow": "Chat & Werkproces",
        "grading_and_feedback": "Beoordeling & Feedback",
        "master_solution_design": "Modeloplossingen",
        "grading_scheme_creation": "Beoordelingsschema's"
      },
      "categoryDescs": {
        "chat_and_workflow": "Hoe de assistent in de chat antwoordt en het werkproces stuurt",
        "grading_and_feedback": "Hoe antwoorden beoordeeld worden en feedback geformuleerd wordt",
        "master_solution_design": "Hoe modeloplossingen gemaakt worden",
        "grading_scheme_creation": "Hoe beoordelingsschema's opgebouwd worden"
      },
      "grammar": {
        "alwaysUseFi": "Altijd de foutenindex (FI) gebruiken",
        "alwaysUseFiDesc": "Gebruikt standaard de foutenindex in plaats van gedetecteerde grammaticaregels uit een geüpload beoordelingsschema. Kan per toets worden overschreven.",
        "languageUseRegradeWordCutoff": "Automatisch taalgebruik & stijl herbeoordelen vanaf (woorden)",
        "languageUseRegradeWordCutoffDesc": "Bij het bewerken van een leerlingantwoord wordt taalgebruik & stijl van de betreffende groep automatisch herbeoordeeld zodra minstens dit aantal woorden is gewijzigd (meerdere kleine bewerkingen tellen samen).",
        "contentRegradeWordCutoff": "Automatisch inhoud herbeoordelen vanaf (woorden)",
        "contentRegradeWordCutoffDesc": "0 = altijd (standaard) — inhoud wordt direct herbeoordeeld bij elke tekstwijziging. Een hogere waarde slaat de automatische herbeoordeling over bij zeer kleine wijzigingen."
      }
    },
    "security": {
      "title": "Account & Veiligheid",
      "changePassword": "Wachtwoord wijzigen",
      "changePasswordDesc": "Veiligheid van je account beheren",
      "changePasswordSent": "We hebben je een link per e-mail gestuurd om je wachtwoord te wijzigen.",
      "changePasswordError": "Er is een probleem opgetreden. Probeer het later opnieuw.",
      "changePasswordConfirmTitle": "Wachtwoord wijzigen?",
      "changePasswordConfirmDesc": "We sturen een link naar {{email}}. Als je die gebruikt en een nieuw wachtwoord instelt, word je op alle andere apparaten afgemeld.",
      "changePasswordSend": "Link versturen",
      "changePasswordCancel": "Annuleren",
      "changePasswordClose": "Sluiten",
      "logout": "Afmelden",
      "logoutDesc": "Veilig uitloggen van dit apparaat"
    },
    "badges": {
      "soon": "Binnenkort"
    }
  },
  "ClassInsights": {
    "overview": "Overzicht",
    "examCount": "Toetsen",
    "subjectCount": "Vakken",
    "gradedCount": "Nagekeken",
    "examListTitle": "Toetsen in deze klas",
    "noExams": "Nog geen toetsen in deze klas.",
    "loading": "Inzichten laden …",
    "statusGraded": "Nagekeken",
    "statusInProgress": "In behandeling",
    "unnamedExam": "Naamloze toets",
    "unknownSubject": "Onbekend vak"
  },
  "Dashboard": {
    "guestMessage": "Ik ben gradi, jouw AI-assistent voor het nakijken van toetsen.",
    "greetings": {
      "opt1": "Welke toetsen gaan we vandaag nakijken?",
      "opt2": "Laten we die stapel toetsen eens wegwerken.",
      "opt3": "Wat staat er vandaag op het programma?",
      "opt4": "Hoe kan ik je vandaag helpen?",
      "opt5": "Fijn dat je er bent. Waarmee gaan we beginnen?",
      "opt6": "Laten we beginnen met nakijken!"
    },
    "studentGreetings": {
      "opt1": "Wat gaan we vandaag leren?",
      "opt2": "Zin om een paar toetsvragen aan te pakken?",
      "opt3": "Wat staat er vandaag op het programma?",
      "opt4": "Hoe kan ik je vandaag helpen?",
      "opt5": "Fijn dat je er bent. Waarmee gaan we beginnen?",
      "opt6": "Laten we beginnen!"
    },
    "fallbackGreeting": "Wat staat er vandaag op het programma?",
    "greetingPrefix": "Hoi",
    "inputPlaceholder": "Stel een vraag...",
    "dropzoneText": "Bestanden hier neerzetten",
    "actions": {
      "startGrading": {
        "label": "Toetsnakijkproces starten",
        "prompt": "Ik wil een nieuwe toetsnakijkronde starten. Begeleid me stapsgewijs door het proces van de upload tot het beoordelingsschema."
      },
      "uploadExam": {
        "label": "Mijn toets uploaden",
        "prompt": "Ik wil een toets uploaden die ik al heb gemaakt, zodat je die voor me kunt nakijken. Hoe beginnen we?"
      },
      "createExam": {
        "label": "Oefentoets maken",
        "prompt": "Ik wil een nieuwe oefentoets maken. Kun je me helpen er een samen te stellen?"
      },
      "howItWorks": {
        "label": "Hoe werkt gradias?",
        "prompt": "Leg me kort en bondig uit hoe gradias werkt en welke stappen ik moet doorlopen voor een succesvolle beoordeling."
      },
      "sampleData": {
        "label": "Testen met voorbeeldgegevens",
        "prompt": "Ik wil het systeem testen, maar ik heb geen eigen toetsen bij de hand. Hoe kan ik testen met een voorbeeldtoets?"
      },
      "taskTypes": {
        "label": "Welke soorten opdrachten zijn er?",
        "prompt": "Welke soorten opdrachten (bijv. open tekst, multiplechoice, wiskundige vergelijkingen) kun je momenteel nakijken?"
      },
      "privacy": {
        "label": "Privacy en veiligheid",
        "prompt": "Hoe gaat gradias om met privacy? Wat gebeurt er met de geüploade toetsen van mijn leerlingen?"
      }
    },
    "alerts": {
      "uploadError": "Fout bij het uploaden van het bestand",
      "noExamId": "Geen examId aanwezig"
    },
    "aria": {
      "uploadFiles": "Bestanden uploaden",
      "submit": "Verzenden",
      "removeFile": "Bestand verwijderen"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Alle stappen voltooid",
      "configRunning": "Klaar - Gereed om door te gaan",
      "readyForConfig": "Gereed voor configuratie",
      "status": "Status",
      "progress": "Voortgang",
      "inProgress": "bezig"
    },
    "steps": {
      "examCreator": {
        "label": "Toets maken",
        "phasePlan": "Toets wordt gepland",
        "phaseMaterial": "Figuren worden gegenereerd",
        "phaseSource": "Opgaven worden geschreven",
        "phaseRepair": "Document wordt afgerond"
      },
      "upload": {
        "label": "Bestandsupload"
      },
      "studentAssignment": {
        "label": "Leerlingtoewijzing",
        "activeWait": "Wachten op bevestiging",
        "activeAssign": "Leerlinginzendingen toewijzen"
      },
      "structure": {
        "label": "Toetsstructuur",
        "active": "Opdrachten worden herkend"
      },
      "answers": {
        "label": "Antwoorden van leerlingen",
        "active": "Antwoorden worden verwerkt"
      },
      "masterSolution": {
        "label": "Modeloplossing",
        "activeDetect": "Modeloplossing wordt herkend",
        "activeCreate": "Modeloplossing wordt gemaakt",
        "activeComplete": "Modeloplossing wordt aangevuld"
      },
      "gradingScheme": {
        "label": "Beoordelingscriteria",
        "activeDetect": "Beoordelingscriteria worden herkend",
        "activeCreate": "Beoordelingscriteria worden gemaakt",
        "activeComplete": "Beoordelingscriteria worden aangevuld"
      },
      "grading": {
        "label": "Correctie",
        "active": "Beoordeling is bezig"
      },
      "summary": {
        "label": "Resultatenoverzicht"
      }
    },
    "badges": {
      "uncertainties": "Onzekerheden",
      "errorRegions": "Foutieve regio's",
      "errorSubmissions": "Foutieve inzendingen",
      "documentEncrypted": "Document beveiligd"
    },
    "ui": {
      "showProgress": "Nakijkvoortgang tonen",
      "dropFilesHere": "Bestanden hier neerzetten",
      "uploadFiles": "Bestanden uploaden",
      "waitUpload": "Wacht op upload",
      "sendMessage": "Bericht verzenden",
      "privacyNotice": "100% AVG-conform. Jouw gegevens en de documenten van leerlingen worden niet gebruikt voor AI-training.",
      "learnMore": "Meer informatie."
    },
    "alerts": {
      "uploadError": "Fout bij het uploaden van het bestand",
      "noExamId": "Geen examId aanwezig"
    }
  },
  "TokenInput": {
    "placeholder": "Stel een vraag..."
  },
  "Chat": {
    "auth": {
      "login": "Aanmelden",
      "register": "Registreren"
    },
    "loading": {
      "masterSolutions": "Modeloplossingen laden...",
      "examData": "Toetsgegevens & afbeeldingen laden...",
      "extractingTasks": "Opdrachten worden geëxtraheerd... {{finished}}/{{total}}",
      "splitThinkingMessage": "Ik deel de leerlinginzendingen in",
      "structureThinkingMessage": "Ik herken de toetsstructuur",
      "examStructure": "Toetsstructuur laden...",
      "pages": "Pagina's laden...",
      "summary": "Samenvatting laden..."
    },
    "alerts": {
      "errorOccurred": "Sorry, er is een fout opgetreden. Probeer het later opnieuw.",
      "reportsBlocked": "PDF-rapporten zijn pas beschikbaar als alle hoofdopdrachten zijn goedgekeurd of als de AI-betrouwbaarheid hoger is dan {{threshold}}%.",
      "noSubmissionsForReports": "Geen inzendingen met rapportgegevens gevonden.",
      "reportsFailed": "PDF-rapporten konden ikke worden gemaakt. Probeer het opnieuw."
    },
    "sampleExamIntro": "Ik wil deze toets nakijken met de volgende documenten:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Opdrachtzones aanpassen",
      "msedit": "Modeloplossing / beoordelingsschema bewerken",
      "correction": "Correctie",
      "summary": "Samenvatting nakijkronde",
      "structureeditor": "Toetsstructuur bewerken",
      "submissioncheck": "Paginatoewijzing controleren",
      "demoselector": "Demo selecteren",
      "examcreator": "Toets maken",
      "legal": "Legal Navigator (juridisch & regelgeving)",
      "default": "Detailweergave"
    },
    "legalNavigator": {
      "title": "Externe inhoud: ChatGPT-app van OpenAI",
      "notice": "De Legal Navigator is een ChatGPT-app van OpenAI. Bij het laden worden je IP-adres en browsergegevens naar OpenAI verzonden, mogelijk ook naar de VS.",
      "noStudentData": "Voer daar geen persoonsgegevens van leerlingen in.",
      "privacyLink": "Privacybeleid van OpenAI",
      "load": "Inhoud laden"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Grootte aanpassen",
      "toSummaryTitle": "Naar overzicht",
      "backToSummary1": "Terug naar",
      "backToSummary2": "Overzicht",
      "restore": "Herstellen",
      "fullscreen": "Volledig scherm",
      "close": "Sluiten"
    },
    "grading": {
      "prevTask": "Vorige opdracht",
      "nextTask": "Volgende opdracht",
      "taskXofY": "Opdracht {{current}} van {{total}}",
      "taskName": "Opdracht {{number}}",
      "nextUncertainty": "Volgende onzekerheid ({{count}})",
      "uncertaintiesLeft": "Nog {{count}} onzekerheden over",
      "backToSummary1": "Terug naar",
      "backToSummary2": "Overzicht",
      "submissionX": "Inzending {{id}}",
      "pages": "Pagina's:",
      "pageX": "Pagina {{page}}",
      "addBoundingBox": "Nieuw selectiekader toevoegen",
      "extractedText": "Geëxtraheerde tekst",
      "verified": "Gecontroleerd",
      "consistencyAdjusted": "Automatisch aangepast voor consistentie met andere inzendingen",
      "bboxConfidence": "Selectiekader-betrouwbaarheid: {{conf}}%",
      "review": "Controleren",
      "noTextExtracted": "Geen tekst geëxtraheerd.",
      "imageContent": "Afbeelding (geen tekstherkenning) - de herkende beelduitsnede wordt direct gebruikt voor verdere verwerking",
      "aiGrading": "AI-beoordeling",
      "pts": "Ptn.",
      "points": "Punten:",
      "noGradingYet": "Nog geen beoordeling aanwezig.",
      "gradingScheme": "Beoordelingsschema",
      "expand": "Uitklappen",
      "collapse": "Inklappen",
      "maxPoints": "Max punten: {{points}}",
      "noGradingSchemeYet": "Nog geen beoordelingsteken aanwezig.",
      "boxModeContent": "Inhoud",
      "boxModeLanguageUse": "Taalgebruik & Stijl",
      "groupLanguageUseRule": "Groep: taak {{tasks}}",
      "groupLanguageUseRuleNumbered": "Groep {{number}}: taak {{tasks}}",
      "editLanguageUseGroupTasks": "Taken van deze groep bewerken",
      "deleteLanguageUseGroup": "Deze Taalgebruik & Stijl-regel verwijderen",
      "deleteLanguageUseGroupConfirm": "Deze Taalgebruik & Stijl-regel verwijderen? Dit kan niet ongedaan worden gemaakt.",
      "deleteLanguageUseGroupBlocked": "Verwijderen is niet mogelijk terwijl er wordt beoordeeld.",
      "languageUseGroupPickerInfo": "Vink een taak aan om deze aan deze groep toe te voegen. Vink uit om te verwijderen; als de taak nog een eigen Taalgebruik & Stijl-regel nodig heeft, wordt deze vooraf ingevuld met de tekst van deze groep en 0 punten, zodat je hem terugvindt.",
      "languageUseGroupPickerSaveFailed": "Opslaan mislukt. Probeer het opnieuw.",
      "languageUseGroupPickerEmptyDraft": "Een regel heeft minstens één taak nodig.",
      "deleteBox": "Selectiekader verwijderen",
      "retryOcr": "Tekstherkenning opnieuw proberen",
      "unlockBox": "Selectiekader ontgrendelen",
      "lockBox": "Selectiekader vergrendelen",
      "noSubmissionsFound": "Geen inzendingen gevonden.",
      "examPageX": "Toetspagina {{page}}",
      "rerunningOcr": "Tekstherkenning wordt herhaald...",
      "regrading": "Opnieuw beoordelen...",
      "regradingQueued": "In de wachtrij..."
    },
    "msgs": {
      "noTasksFound": "Geen opdrachten gevonden.",
      "prevTask": "Vorige opdracht",
      "nextTask": "Volgende opdracht",
      "task": "Opdracht",
      "taskMain": "Opdracht {{main}}",
      "taskSub": "Opdracht {{main}}.{{sub}}",
      "uncertaintiesLeft": "Nog {{count}} onzekerheden over",
      "nextUncertainty": "Volgende onzekerheid ({{count}})",
      "taskExcerpt": "Opdrachtfragment",
      "noImageAvailable": "Geen afbeelding beschikbaar...",
      "masterSolution": "Modeloplossing",
      "aiGeneratedProposalTooltip": "Door AI gegenereerd voorstel",
      "aiGeneratedProposal": "AI-gegenereerd voorstel",
      "review": "Controleren",
      "approvalRequiresPoints": "Goedkeuren is pas mogelijk als de punten groter zijn dan 0.",
      "saveRequiresPoints": "Opslaan is pas mogelijk als de punten groter zijn dan 0.",
      "enterMasterSolution": "Modeloplossing hier invoeren...",
      "noMasterSolutionYet": "Nog geen modeloplossing aanwezig...",
      "gradingScheme": "Beoordelingsschema",
      "maxPoints": "Max punten",
      "maxPointsValue": "Max punten: {{points}}",
      "enterGradingScheme": "Beoordelingsschema hier invoeren...",
      "noGradingSchemeYet": "Nog geen beoordelingsschema aanwezig...",
      "gradingSchemeRefining": "Beoordelingscriteria worden bijgewerkt...",
      "masterSolutionRefining": "Modeloplossing wordt bijgewerkt..."
    },
    "submissionCheck": {
      "pageShort": "P. {{page}}",
      "zoomPage": "Pagina {{page}} vergroten",
      "pageAlt": "Pagina",
      "loading": "Laden...",
      "newStudent": "Nieuwe leerling",
      "readOnly": "Alleen lezen",
      "saving": "Opslaan...",
      "saved": "Opgeslagen",
      "unsavedUnassigned": "Niet opgeslagen – niet-toegewezen pagina's",
      "unsavedUnassignedHint": "Sleep alle niet-toegewezen pagina's naar een leerling, dan wordt automatisch opgeslagen.",
      "saveFailed": "Niet opgeslagen – fout",
      "saveFailedHint": "Opslaan is mislukt. Bij de volgende wijziging of bij het sluiten wordt het opnieuw geprobeerd.",
      "reloaded": "Opnieuw geladen",
      "reloadedHint": "De inzendingen zijn intussen gewijzigd. De opgeslagen toewijzing is opnieuw geladen.",
      "unassignedPagesTitle": "Actie vereist: Niet-toegewezen pagina's ({{count}})",
      "unassignedPagesHint": "Sleep deze pagina's naar de mappen van de leerlingen.",
      "newStudentIndexed": "Nieuwe leerling {{index}}",
      "studentIndexed": "Leerling {{index}}",
      "enterName": "Naam invoeren...",
      "pageX_one": "{{count}} pagina",
      "pageX_other": "{{count}} pagina's",
      "splitConfidenceHover": "Splitsingsbetrouwbaarheid: {{percent}}%",
      "splitPercent": "Splitsing {{percent}}%",
      "deleteStudent": "Leerling verwijderen",
      "dragHint": "Sleep documenten hiernaartoe om ze aan {{name}} toe te wijzen",
      "assignmentNotes": "Opmerkingen over toewijzing",
      "previewPageAlt": "Voorbeeld pagina {{page}}",
      "pageCurrentOfTotal": "Pagina {{current}} van {{total}}",
      "locked": "Bevestigd",
      "lockedHint": "Al bevestigd – kan niet meer worden bewerkt."
    },
    "summary": {
      "studentsOverview": "Samenvatting per leerling",
      "studentsOverviewDesc": "Gedetailleerde punten en AI-beoordeling per opdracht",
      "searchStudent": "Leerlingnaam zoeken...",
      "student": "Leerling",
      "pointsAbbr": "P.",
      "total": "Totaal",
      "percentage": "Procent",
      "grade": "Cijfer",
      "noHits": "Geen resultaten.",
      "aiConfidenceHover": "AI-betrouwbaarheid: {{percent}}% - Handmatig controleren a.u.b.",
      "aiUncertainties": "AI-onzekerheden",
      "aiUncertaintiesDesc": "Controleer gevallen waarin de AI onzeker is om eerlijke beoordelingen te garanderen.",
      "openDecisions": "{{count}} openstaande beslissingen",
      "sortBy": "Sorteren op",
      "task": "Opdracht",
      "aiUncertainty": "AI-onzekerheid",
      "confidence": "AI-betrouwbaarheid:",
      "points": "Punten:",
      "toGrading": "Naar nakijken",
      "confirmed": "Bevestigd",
      "confirm": "Bevestigen",
      "noClarificationNeeded": "Geen actie vereist.",
      "worstAvg": "Slechtste gemiddelde",
      "noDataYet": "Nog geen gegevens",
      "avgSuffix": "gemiddeld",
      "frequentErrors": "Meest voorkomende foutenbronnen",
      "metricsPerTask": "Metrieken per opdracht",
      "gradeDistribution": "Cijferverdeling",
      "count": "Aantal",
      "pdfReports": "PDF-rapporten",
      "downloadingPdf": "PDF-rapporten worden gemaakt...",
      "downloadPdf": "PDF-rapporten downloaden",
      "csvExport": "CSV-cijfersexport",
      "notConnected": "Nog niet verbonden",
      "notMet": "Niet behaald",
      "downloadingCsv": "CSV wordt gemaakt...",
      "downloadCsv": "CSV downloaden",
      "gradeScale": "Normering",
      "gradeFrom": "Cijfer {{grade}} vanaf",
      "normalDistribution": "Normale verdeling (Gauss-curve)",
      "activated": "Geactiveerd",
      "deactivated": "Gedeactiveerd",
      "curveStrength": "Curving-sterkte",
      "curvingComingSoon": "Curving is nog niet beschikbaar. Deze functie komt binnenkort.",
      "noSubmissionsFound": "Geen nagekeken inzendingen gevonden.",
      "avgPointsReached": "Ø Behaalde punten",
      "pointsReached": "Behaalde punten",
      "gradeSystem": "Cijfersysteem",
      "gradeBorders": "Cijfergrenzen",
      "lowestGradeLabel": "laagste cijfer (vanaf 0%)",
      "tabs": {
        "students": "Leerlingoverzicht",
        "clarification": "Actie vereist",
        "insights": "Opdracht-insights",
        "grades": "Cijferverdeling",
        "curving": "Normering & Curving",
        "export": "Exporteren",
        "languageUse": "Taalgebruik & Stijl & Grammatica"
      },
      "gradingScales": {
        "german16": "Duits (1–6)",
        "drittel": "Derden (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Punten (0–15)",
        "numeric10": "10-punten",
        "percentage": "Procent",
        "custom": "Aangepast"
      },
      "grammar": "Grammatica",
      "fehlerindex": "Foutenindex (FI)",
      "grammarFiColumnHint": "Bevat alleen taken die nog via de foutenindex worden beoordeeld; op regels gebaseerde taken hebben eigen kolommen.",
      "taskLanguageUseColumn": "{{label}} · Taalgebruik & Stijl",
      "grammarTab": {
        "noGrammarTasks": "Dit examen bevat geen taken met grammaticabeoordeling.",
        "fiTitle": "Foutenindex-aftrek",
        "fiDesc": "Foutenindex = fouten per 100 woorden. Bij overschrijding van de grenzen wordt het eindcijfer met cijferstappen verlaagd.",
        "fiUnsupportedScale": "Bij een procentuele schaal is geen aftrek in cijferstappen mogelijk.",
        "fiAbove": "Bij foutenindex boven",
        "deductSteps": "aftrek (cijferstappen)",
        "matrixTitle": "Grammaticafouten per leerling en taak",
        "matrixDesc": "Aantal fouten (foutenindex tussen haakjes). Klik op een cel om de correctie in grammaticamodus te openen.",
        "fiSwitchTitle": "Foutenindex toepassen voor deze toets",
        "fiSwitchDesc": "Gebruikt standaard je profielinstelling; schakel in om dit alleen voor deze toets te overschrijven.",
        "gradeWithFi": "Cijfer (met FI)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Taalgebruik & Stijl-regels gebruikt bij de beoordeling",
        "ownRuleEntry": "{{label}}: eigen regel ({{points}} pt)",
        "groupRuleEntry": "{{label}} ({{points}} pt)",
        "teacherRulesActive": "Taalgebruik & Stijl wordt direct tijdens het beoordelen meegenomen volgens je persoonlijke regels. De foutenindex-aftrek is uitgeschakeld."
      }
    },
    "structureEditor": {
      "pointsInconsistent": "De punten kloppen niet. Geef op elk niveau alle taken punten (die samen het totaal van de bovenliggende taak vormen) of laat ze allemaal leeg. Corrigeer de gemarkeerde taken:",
      "pointsInconsistentTask": "Taak {{path}} mist punten",
      "totalPoints": "Totaal aantal punten (incl. subtaken)",
      "ownPoints": "Eigen punten (het eigen antwoord van deze taak)",
      "tasksWithoutRegion": "Taken zonder gemarkeerd gebied",
      "noPages": "Geen pagina's aanwezig.",
      "taskAreasDetected_one": "{{count}} opdrachtzone herkend",
      "taskAreasDetected_other": "{{count}} opdrachtzones herkend",
      "addArea": "Zone toevoegen",
      "remove": "Verwijderen",
      "resetZoom": "Zoom herstellen",
      "readOnly": "Alleen lezen",
      "saving": "Opslaan...",
      "saved": "Opgeslagen",
      "blankExamPage": "Blanke toetspagina {{page}}",
      "deleteBbx": "BBX verwijderen",
      "retryOcr": "Tekstherkenning opnieuw proberen",
      "noTasksOnPage": "Geen opdrachten op deze pagina",
      "task": "Opdracht",
      "noText": "Geen tekst",
      "imageContent": "Afbeelding (geen tekstherkenning) - de herkende beelduitsnede wordt direct gebruikt voor verdere verwerking",
      "additionalInfo": "Extra info",
      "noContent": "Geen inhoud",
      "linkedTasks": "Gekoppelde opdrachten",
      "noTasks": "Geen opdrachten"
    },
    "demoSelector": {
      "title": "Demo selecteren",
      "description": "Kies een voorbeeldtoets. gradias simuleert de upload en start de extractie automatisch.",
      "examCount_one": "{{count}} toets",
      "examCount_other": "{{count}} toetsen",
      "studentCount_one": "{{count}} leerling",
      "studentCount_other": "{{count}} leerlingen",
      "examLanguage": "Toetstaal",
      "subjects": {
        "math": "Wiskunde",
        "english": "Engels",
        "technical": "Beroepsonderwijs",
        "biology": "Biologie",
        "spanish": "Spaans",
        "french": "Frans",
        "physics": "Natuurkunde",
        "political_education": "Politieke vorming",
        "german": "Duits"
      },
      "grades": {
        "gesamtschule": "Brede scholengemeenschap",
        "highSchool": "Gymnasium / VWO",
        "elementarySchool": "Basisschool",
        "vocationalSchool": "Volwasseneneducatie",
        "middleSchool": "Middenschool / HAVO",
        "university": "Universiteit",
        "primarySchool": "Basisschool"
      },
      "exams": {
        "kaarst": {
          "name": "Wiskunde Functieonderzoek",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "arne": {
          "name": "Wiskunde Groep 8 Breuken",
          "description": "Leerlinginzendingen"
        },
        "lynehamMath": {
          "name": "Wiskunde",
          "description": "Leerlinginzendingen"
        },
        "tuevBauleiter": {
          "name": "Uitvoerder bouw",
          "description": "Leerlinginzendingen & modeloplossing"
        },
        "tuvPhotovoltaik": {
          "name": "Zonnepanelen / PV",
          "description": "Leerlinginzendingen & modeloplossing"
        },
        "engVocabulary": {
          "name": "Woordestoets (Engels)",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "bioImageLabeling": {
          "name": "Afbeelding benoemen (Biologie)",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing & blanco toets"
        },
        "mathProofFr": {
          "name": "Wiskundig bewijs",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing & blanco toets"
        },
        "mathProofEng": {
          "name": "Wiskundig bewijs",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing & blanco toets"
        },
        "plotting": {
          "name": "Grafiek tekenen",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing & blanco toets"
        },
        "curveAnalysis": {
          "name": "Functieonderzoek",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing & blanco toets"
        },
        "calculationDe": {
          "name": "Natuurkunde",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "dictationFr": {
          "name": "Dictee — Frans",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "dictationEs": {
          "name": "Dictee — Spaans",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "calculationFr": {
          "name": "Berekening",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "calculationEs": {
          "name": "Berekening",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "calculationEn": {
          "name": "Berekening",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "multipleChoiceDe": {
          "name": "Multiple Choice",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "multipleChoiceEn": {
          "name": "Multiple Choice",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "multipleChoiceFr": {
          "name": "Multiple Choice",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "multipleChoiceEs": {
          "name": "Multiple Choice",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "politics12German": {
          "name": "Politieke vorming — Klas 12",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "poetry12German": {
          "name": "Gedichtanalyse — Klas 12",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "poetry12English": {
          "name": "Gedichtanalyse — Klas 12",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "poetry12French": {
          "name": "Gedichtanalyse — Klas 12",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "materialBasedEnglish": {
          "name": "Materiaalgestuurd schrijven",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        },
        "materialBasedGerman": {
          "name": "Materiaalgestuurd schrijven",
          "description": "Volledige dataset: leerlinginzendingen, modeloplossing, beoordelingsschema & blanco toets"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Opslaan en opnieuw compileren…",
      "unsavedChanges": "Niet-opgeslagen wijzigingen",
      "allChangesSaved": "Alle wijzigingen opgeslagen",
      "readOnlyBanner": "Dit examen is read-only: er bestaat al een modeloplossing, een beoordelingsschema of inzendingen van leerlingen gebaseerd op de taakstructuur, dus hier kunnen geen wijzigingen meer worden aangebracht.",
      "generatingExam": "Examen wordt gegenereerd…",
      "refiningExam": "Examen wordt bijgewerkt…",
      "downloadPdf": "PDF downloaden",
      "confirmCreation": "Examen bevestigen",
      "confirmingCreation": "Bevestigen…",
      "confirmHint": "Bevestig het examen om het bewerken af te ronden. Downloaden en online inleveren zijn pas na deze definitieve bevestiging mogelijk, en daarna kan het examen niet meer worden bewerkt.",
      "confirmed": "Bevestigd",
      "readOnly": "Alleen lezen",
      "confirmedBanner": "Dit examen is bevestigd en kan niet meer worden bewerkt. Downloaden en online inleveren zijn beschikbaar.",
      "confirmFailed": "Het examen kon niet worden bevestigd: {{message}}",
      "preparingPdf": "PDF wordt voorbereid…",
      "notSaved": "Niet opgeslagen: {{message}}",
      "seeProblemsBelow": "zie problemen hieronder",
      "noExam": "Geen toets.",
      "noSourceYet": "Deze toets heeft nog geen bron.",
      "noPreviewYet": "Nog geen gecompileerde voorbeeldweergave — klik op een blok of punt om te bewerken en er een te genereren.",
      "tellAiPlaceholder": "Vertel de AI wat er moet veranderen ...",
      "delete": "Verwijderen",
      "applying": "Wordt toegepast …",
      "send": "Verzenden",
      "done": "Klaar",
      "describeAiPlaceholder": "Beschrijf de AI welke taak hier moet worden toegevoegd ...",
      "add": "Toevoegen",
      "adding": "Wordt toegevoegd …",
      "task": "Taak {{number}}",
      "taskNumber": "Taaknummer",
      "type": "Type",
      "points": "Punten",
      "lines": "Regels",
      "taskText": "Taaktekst",
      "material": "Materiaal",
      "title": "Titel",
      "usedByTasks": "Gebruikt door taken (kommagescheiden nummers)",
      "text": "Tekst",
      "multipleChoice": "Meerkeuze",
      "removeOption": "Optie verwijderen",
      "addOption": "+ Optie toevoegen",
      "figureProperties": "Afbeeldingseigenschappen",
      "caption": "Bijschrift",
      "examSetup": "Toetsinstellingen",
      "subject": "Vak",
      "class": "Klas",
      "duration": "Duur",
      "totalPoints": "Totaal aantal punten",
      "globalHints": "Algemene aanwijzingen / instructies",
      "studentView": "Online invullen"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Groepeert subopdrachten, vereist geen eigen antwoord",
    "default": "Algemeen opdrachttype, als geen ander type past",
    "shortText": "Kort schriftelijk antwoord (enkele zinnen)",
    "essay": "Langere, gestructureerde lopende tekst",
    "diagram": "Technische tekening, bijv. stroomschema of elektrisch circuit",
    "sketch": "Tekening uit de vrije hand of schets",
    "gapText": "Invulaattekst invullen",
    "labelImage": "Delen van een afbeelding of diagram benoemen",
    "multipleChoice": "Kiezen uit vooraf gedefinieerde opties",
    "imageAnalysis": "Afbeelding beschrijven of interpreteren",
    "mapping": "Bijbehorende objecten/alternatieven verbinden",
    "legalCase": "Juridische casus (beoordelingsstijl)",
    "calculation": "Wiskundige of natuurkundige berekening",
    "mathematicalProof": "Formeel wiskundig bewijs",
    "curveAnalysis": "Functieonderzoek (nulpunten, extrema, ...)",
    "plotting": "Grafiek, functie of punten in een assenstelsel tekenen",
    "geometry": "Geometrische constructies of berekeningen (tekening)",
    "programming": "Broncode schrijven of analyseren",
    "art": "Kunstwerk of artistiek ontwerp maken",
    "dictation": "Gedicteerde tekst opschrijven",
    "translation": "Tekst of woorden vertalen naar een andere taal",
    "chemicalFormula": "Chemische reactievergelijkingen of formules",
    "music": "Noten lezen of schrijven",
    "literaryAnalysisPoetry": "Een gedicht analyseren",
    "analysisNonFiction": "Een non-fictietekst analyseren",
    "materialBasedEssay": "Een tekst schrijven op basis van aangeleverde materialen"
  },
  "TaskTypes": {
    "taskFrame": "Taakkader",
    "default": "Standaard",
    "shortText": "Korte tekst",
    "essay": "Essay",
    "diagram": "Diagram",
    "sketch": "Schets",
    "gapText": "Invultekst",
    "labelImage": "Afbeelding labelen",
    "multipleChoice": "Multiple Choice",
    "imageAnalysis": "Beeldanalyse",
    "mapping": "Koppelen",
    "legalCase": "Rechtszaak",
    "calculation": "Berekening",
    "mathematicalProof": "Wiskundig bewijs",
    "curveAnalysis": "Functieonderzoek",
    "plotting": "Grafiek tekenen",
    "geometry": "Geometrie",
    "programming": "Programmeren",
    "art": "Kunst",
    "dictation": "Dictee",
    "translation": "Vertaling",
    "chemicalFormula": "Chemische formule",
    "music": "Muziek",
    "literaryAnalysisPoetry": "Gedichtanalyse",
    "analysisNonFiction": "Analyse non-fictietekst",
    "materialBasedEssay": "Materiaalgestuurd schrijven"
  },
  "GapText": {
    "gap": "Gat",
    "correct": "Goed",
    "incorrect": "Fout",
    "empty": "Leeg",
    "points": "Punten",
    "expectedAnswer": "Verwacht antwoord",
    "studentAnswer": "Antwoord leerling",
    "status": "Status"
  },
  "progress": {
    "analyzingSplit": "Splitsing wordt geanalyseerd",
    "extractingAnswers": "Antwoorden van leerlingen worden geëxtraheerd...",
    "errorExtractingAnswers": "Fout bij het extraheren van antwoorden van leerlingen",
    "answersExtracted": "Antwoorden van leerlingen geëxtraheerd",
    "extractingMasterSolution": "Inhoud modeloplossing extraheren",
    "errorStructureMasterSolution": "Fout bij het maken van de opdrachtstructuur (modeloplossing)",
    "errorExtractingMasterSolution": "Fout bij het extraheren van de modeloplossing",
    "masterSolutionExtracted": "Modeloplossing geëxtraheerd",
    "extractingGradingScheme": "Beoordelingscriteria extraheren",
    "errorStructureGradingScheme": "Fout bij het maken van de opdrachtstructuur (beoordelingscriteria)",
    "errorExtractingGradingScheme": "Fout bij het extraheren van de beoordelingscriteria",
    "gradingSchemeExtracted": "Beoordelingscriteria geëxtraheerd",
    "noUsableMasterSolution": "Geen bruikbare inhoud voor modeloplossing herkend. Controleer het bestand of pas de toewijzing aan.",
    "noUsableGradingScheme": "Geen bruikbare beoordelingscriteria herkend. Controleer het bestand of pas de toewijzing aan.",
    "analyzingStructure": "Structuur van de toets wordt geanalyseerd",
    "noSubmissions": "Geen inzendingen aanwezig",
    "errorStructureAnalysis": "Fout bij de structuuranalyse van de toets",
    "noTasksInStructure": "Geen opdrachten gevonden in de structuuranalyse",
    "extractingTaskDescriptions": "Opdrachtbeschrijvingen extraheren",
    "errorTaskDescriptions": "Fout bij het extraheren van de opdrachtbeschrijvingen",
    "taskDescriptionsExtracted": "Opdrachtbeschrijvingen geëxtraheerd",
    "taskStructureCreated": "Opdrachtstructuur aangemaakt",
    "waitingForStructureConfirmation": "Wachten op bevestiging van de toetsstructuur door de gebruiker",
    "structureConfirmed": "Toetsstructuur bevestigd",
    "structureConfirmationTimeout": "Bevestiging van de toetsstructuur is verlopen",
    "errorWaitingStructureConfirmation": "Fout bij het wachten op de bevestiging van de toetsstructuur",
    "errorProcessingStructureConfirmation": "Fout bij het verwerken van de toetsstructuurbevestiging",
    "errorCreatingTaskStructure": "Fout bij het maken van de opdrachtstructuur",
    "pipelineFailedPrematurely": "Pipeline voortijdig mislukt",
    "assignmentConfirmed": "Toewijzing bevestigd",
    "gradingRunning": "Beoordeling is bezig...",
    "gradingTaskX": "Opdracht {{taskNumber}} beoordelen...",
    "gradingCompleted": "Beoordeling voltooid",
    "gradingTaskXCompleted": "Beoordeling voor opdracht {{taskNumber}} voltooid"
  },
  "upload": {
    "noExamId": "Geen toets-ID gevonden",
    "noFileSelected": "Geen bestand geselecteerd",
    "processingFailed": "Bestand kon niet worden verwerkt",
    "invalidFileType": "Ongeldig bestandstype. Selecteer een PNG- of PDF-bestand.",
    "uploadError": "Fout bij het uploaden van het bestand",
    "studentName": "Leerling {{index}}",
    "noExamIdForReupload": "Fout: Geen toets-ID aanwezig voor herupload.",
    "reuploadCancelled": "SYSTEM INFO: Upload-afbreken verwerkt.",
    "reuploadCancelFailed": "SYSTEM INFO: Upload-afbreken kon niet volledig worden verwerkt.",
    "filesMissing": "SYSTEM BLOCK: De volgende bestanden zijn niet gevonden in de uploadopslag: {{files}}. Zorg ervoor dat de bestandsnamen exact overeenkomen met de geüploade bestanden.",
    "assignmentMismatch": "SYSTEM BLOCK: De volgende bestandstoewijzingen komen niet overeen met het laatste voorstel. Roep send_assignment_confirmation_message aan en bevestig de nieuwe toewijzing met de gebruiker.\n{{lines}}",
    "reuploadStarted": "De herupload van de bestanden is op de achtergrond gestart. {{extra}}",
    "splitStarted": "De verdeling voor de leerlinginzendingen is gestart.",
    "assignmentProposalSent": "Bericht met toewijzingsvoorstel verzonden.",
    "assignmentConfirmationMessage": "Ik ben nog niet zeker van de bestandstoewijzing en wil dat je dit even controleert.\n\nBevestig in het drag-and-drop-gebied of de voorgestelde toewijzing klopt, of pas deze daar aan. Daarna kan ik direct weer verder.",
    "assignmentProposalFallback": "Controleer mijn toewijzingsvoorstel en bevestig de bestandstoewijzing.",
    "categorySubmissions": "Leerlinginzendingen",
    "categoryMasterSolution": "Modeloplossing",
    "categoryGradingScheme": "Beoordelingsschema",
    "categoryBlankExam": "Leere toets",
    "lowConfidenceListFormat": "'{{file}}' (gepland als {{category}})",
    "mismatchFormat": "- {{name}}: laatst voorgesteld als \"{{proposed}}\", nu meegestuurd als \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Onbekende leerling",
    "studentNumber": "Leerling {{number}}",
    "pageAssignmentError": "Niet elke pagina is exact één keer toegewezen",
    "nonConsecutive": "Niet-opeenvolgende pagina's voor {{names}} toegewezen (hersortering door agenten)",
    "uncertainty": "Onzekerheid bij {{names}}",
    "outlierLongExtremeSingle": "Inzending van {{names}} is extreem lang",
    "outlierLongExtremePlural": "Inzendingen van {{names}} zijn extreem lang",
    "outlierShortExtremeSingle": "Inzending van {{names}} is extreem kort",
    "outlierShortExtremePlural": "Inzendingen van {{names}} zijn extreem kort",
    "outlierLongSingle": "Inzending van {{names}} is ongewoon lang",
    "outlierLongPlural": "Inzendingen van {{names}} zijn ongewoon lang",
    "outlierShortSingle": "Inzending van {{names}} is ongewoon kort",
    "outlierShortPlural": "Inzendingen van {{names}} zijn ongewoon kort",
    "missingStudentNameSingle": "Voor {{missingCount}} van de {{totalCount}} leerlingen kon geen naam worden geëxtraheerd",
    "missingStudentNamePlural": "Voor {{missingCount}} van de {{totalCount}} leerlingen kon geen naam worden geëxtraheerd",
    "splitAgentFailure": "Fout split-agent{{suffix}}",
    "errorPrefix": "Fout",
    "warningPrefix": "Waarschuwing",
    "parseErrorFallback": "De gegevens konden niet worden verwerkt. Controleer de toewijzing in het Canvas.",
    "messageError": "Ik heb {{count}} leerlingen gevonden met elk {{range}} pagina's, maar er is een probleem opgetreden bij de automatische toewijzing van de pagina's:\n{{problem}}\n\nControleer de toewijzing in het toewijzings-Canvas en corrigeer deze indien nodig handmatig. Zodra je klaar bent, bevestig dit dan in de chat of via de knop, zodat we verder kunnen gaan.",
    "messageWarning": "Ik heb {{count}} leerlingen gevonden met elk {{range}} pagina's, maar er zijn de volgende opmerkingen:\n{{problem}}\n\nAls je wilt, kun je de opmerkingen in het toewijzings-Canvas controleren. Bevestig anders gewoon, zodat we verder kunnen gaan.",
    "messageSuccess": "Ik heb {{count}} leerlingen gevonden met elk {{range}} pagina's. De toewijzing was eenduidig. Bij alle leerlingen kon een naam worden geëxtraheerd. Bevestig a.u.b. zodat we verder kunnen gaan.",
    "confirmationRequested": "Splitsingsbevestiging vereist",
    "splitAgentFailed": "De automatische toewijzing van de leerlinginzendingen is mislukt. Probeer de upload later opnieuw."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**Over de punten:** Ik heb voor sommige taken punten gedetecteerd. Als je een beoordelingsschema met puntenaanduiding uploadt (of al hebt geüpload), worden de punten daaruit overgenomen; je kunt de punten in het canvas dan negeren. Ze zijn alleen relevant als je beoordelingsschema deze niet bevat of als je er een wilt laten genereren.\n\nPuntenregels: geef per taak alle directe subtaken punten die samen het totaal van de bovenliggende taak vormen, of geen enkele. Als je de subtaken geen punten geeft maar alleen een totaal, verdeelt de AI ze later automatisch bij het genereren van het beoordelingsschema.",
    "textCutoff": "Opdrachttekst onvolledig",
    "missingInformation": "ontbrekende informatie",
    "imageUnreadable": "Afbeelding onleesbaar",
    "task": "Opdracht",
    "mainTasks_one": "Ik heb {{mainCount}} hoofdopdracht herkend.",
    "mainTasks_other": "Ik heb {{mainCount}} hoofdopdrachten herkend.",
    "mainAndSubTasks_one": "Ik heb {{mainCount}} hoofdopdrachten en {{subCount}} subopdracht herkend.",
    "mainAndSubTasks_other": "Ik heb {{mainCount}} hoofdopdrachten and {{subCount}} subopdrachten herkend.",
    "intro": "### Ik heb de volgende opdrachtstructuur geïdentificeerd:\n\n{{countText}}",
    "problemsIntro": "\n\nBij de opdrachtenherkenning zijn de volgende problemen opgetreden: {{warnings}}. Bekijk de onzekerheden in het Canvas, bewerk ze indien nodig en bevestig dan via de knop of in de chat.",
    "uncertaintyIntro": "\n\nBij de opdrachtenherkenning zijn er onzekerheden bij {{labels}}. Bekijk de onzekerheden in het Canvas, bewerk ze indien nodig en bevestig dan via de knop of in de chat.",
    "success": "\n\nEr zijn geen problemen opgetreden bij de opdrachtenherkenning. Als je wilt, kun je ze alsnog in detail bekijken in het Canvas, bevestig anders via de knop of in de chat."
  },
  "chatMessages": {
    "emptyState": "Start een gesprek door hieronder een bericht te typen",
    "newMessage": "Nieuw bericht",
    "cancel": "Annuleren",
    "send": "Verzenden",
    "edit": "Bewerken",
    "editInCanvas": "In Canvas bewerken",
    "confirmed": "Bevestigd",
    "confirm": "Bevestigen",
    "confirmAssignment": "Toewijzing bevestigen",
    "giveFeedback": "Feedback geven",
    "feedbackTitle": "Feedback geven",
    "feedbackDescription": "Laat ons weten hoe we dit antwoord kunnen verbeteren.",
    "feedbackPlaceholder": "Jouw feedback hier...",
    "feedbackSubmit": "Feedback verzenden",
    "submitAssignmentConfirmation": "Ik bevestig de verdeling van de pagina's en de toewijzing aan de leerlingen. Ga a.u.b. verder.",
    "submitStructureConfirmation": "Ik bevestig de opdrachtstructuur",
    "studentSubmissions": "Leerlinginzendingen",
    "masterSolution": "Modeloplossing",
    "gradingScheme": "Beoordelingsschema",
    "blankExam": "Leere toets",
    "confirmedAssignmentIntro": "De bevestigde bestandstoewijzing:",
    "assignmentIntro": "Ik heb de bestanden als volgt toegewezen. Controleer de toewijzing en bevestig deze:"
  },
  "AuthModal": {
    "loginError": "E-mailadres of wachtwoord is onjuist.",
    "signupFailed": "Registratie mislukt. Probeer het opnieuw.",
    "passwordMismatch": "De wachtwoorden komen niet overeen.",
    "forgotPasswordProblem": "Er is een probleem opgetreden. Probeer het later opnieuw.",
    "waitlistTitle": "Je staat op de lijst!",
    "waitlistDesc": "We nemen contact met je op zodra de volgende fase start.",
    "waitlistInactive": "Wachtlijst is momenteel gedeactiveerd.",
    "backToLogin": "Terug naar inloggen",
    "linkSentTitle": "Controleer je inbox",
    "linkSentBody": "Als er een bevestigd account met dit e-mailadres bestaat, ontvang je zo een link om je wachtwoord opnieuw in te stellen. Deze is 1 uur geldig. Kijk ook in je spammap. Geen e-mail ontvangen? Registreer je dan.",
    "linkSentDesc": "Begrepen",
    "linkSentRegister": "Naar registratie",
    "forgotPasswordTitle": "Wachtwoord vergeten?",
    "requestLink": "Link aanvragen",
    "welcomeBack": "Welkom terug",
    "createAccount": "Account aanmaken",
    "emailLabel": "E-mailadres",
    "passwordLabel": "Wachtwoord",
    "forgotPasswordLink": "Wachtwoord vergeten?",
    "loginButton": "Aanmelden",
    "firstNameLabel": "Voornaam",
    "lastNameLabel": "Achternaam",
    "schoolLabel": "School",
    "subjectsLabel": "Vakken",
    "confirmPasswordLabel": "Bevestigen",
    "signupButton": "Registreren",
    "registerHere": "Hier registreren",
    "loginHere": "Hier inloggen",
    "continueGuest": "Doorgaan zonder registratie →",
    "or": "of",
    "continueWithGoogle": "Doorgaan met Google",
    "roleTeacher": "Docent",
    "roleStudent": "Leerling",
    "emailNotVerified": "Bevestig eerst je e-mailadres met de code die we je hebben gestuurd naar:",
    "verifyEmailTitle": "Bevestig je e-mailadres",
    "verifyEmailDesc": "We hebben een bevestigingscode gestuurd naar:",
    "verifyEmailHint": "De code is 15 minuten geldig. Kijk ook in je spammap.",
    "verifyEmailResend": "Nieuwe code versturen",
    "verifyEmailResent": "We hebben je een nieuwe code gestuurd.",
    "verifyEmailWrongAddress": "Verkeerd adres? Wijzigen",
    "verifyCodeLabel": "Bevestigingscode",
    "verifyCodeButton": "Bevestigen",
    "verifyCodeInvalid": "De code is onjuist.",
    "verifyCodeExpired": "De code is verlopen of te vaak verkeerd ingevoerd. Vraag een nieuwe code aan.",
    "changeRole": "Rol wijzigen",
    "roleQuestion": "Ben je docent of leerling?",
    "passwordRequirements": "Minimaal 8 tekens, met hoofdletters en kleine letters, een cijfer en een speciaal teken.",
    "passwordInvalid": "Het wachtwoord voldoet niet aan de eisen.",
    "emailInvalid": "Voer een geldig e-mailadres in.",
    "googleNoAccount": "Er is nog geen account voor dit Google-adres. Registreer je eerst."
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "De afbeelding \"{{name}}\" is te groot (max. 5MB).",
      "previewError": "Voorbeeld kon niet worden gemaakt voor {{name}}.",
      "submitError": "Er is iets misgegaan. Probeer het nog eens."
    },
    "success": {
      "title": "Hartelijk dank voor je feedback!",
      "description": "We hebben je bericht ontvangen. Jouw input helpt ons enorm om Gradias elke dag een stukje beter te maken.",
      "backButton": "Terug naar de toets"
    },
    "header": {
      "title": "Feedback geven"
    },
    "content": {
      "description": "Is je een fout opgevallen, heb je een geniaal idee of wil je ons gewoon iets laten weten? We lezen elk bericht!"
    },
    "categories": {
      "title": "Waar gaat het over?",
      "bug": {
        "title": "Fout / Bug",
        "desc": "Iets werkt niet"
      },
      "feature": {
        "title": "Idee / Wens",
        "desc": "Een nieuwe functie"
      },
      "general": {
        "title": "Overig",
        "desc": "Algemene feedback"
      }
    },
    "message": {
      "title": "Jouw bericht",
      "placeholder": "Beschrijf je situatie zo gedetailleerd mogelijk..."
    },
    "upload": {
      "title": "Screenshot bijvoegen (Optioneel)",
      "clickToSelect": "Klik om afbeeldingen te selecteren",
      "formatConstraint": "PNG, JPG tot max. 5MB per afbeelding",
      "attachedImages": "Bijgevoegde afbeeldingen",
      "removeImage": "Afbeelding verwijderen"
    },
    "submit": {
      "sending": "Wordt verzonden...",
      "send": "Feedback verzenden"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "De toetstoewijzing en het aantal leerlingen zijn succesvol bevestigd. De extractie van de opdrachtstructuur kan nu worden gestart. Bedank de gebruiker voor de bevestiging van de toewijzing en laat de gebruiker in de chat weten dat de extractie van de opdrachtstructuur nu wordt gestart.",
      "pending": "De toetstoewijzing en het aantal leerlingen is nog niet confirmed."
    },
    "structure": {
      "masterAndGrading": "De opdrachtstructuur is succesvol bevestigd. De extractie loopt nu verder op de achtergrond. Er is al een modeloplossing en een beoordelingsschema geüpload en deze worden op de achtergrond verwerkt. Bedank de gebruiker kort voor de bevestiging van de opdrachtstructuur en laat de gebruiker kort weten dat de extractie wordt voortgezet. Stel hem voor om met het nakijken te beginnen.",
      "masterOnly": "De opdrachtstructuur is succesvol bevestigd. De extractie loopt nu verder op de achtergrond. Er is al een modeloplossing geüpload, maar het beoordelingsschema ontbreekt nog. Bedank de gebruiker kort voor de bevestiging van de opdrachtstructuur en laat de gebruiker kort weten dat de extractie wordt voortgezet. Stel hem voor om als volgende stap een op AI gebaseerd beoordelingsschema aan te maken.",
      "gradingOnly": "De opdrachtstructuur is succesvol bevestigd. De extractie loopt nu verder op de achtergrond. Er is al een beoordelingsschema geüpload, maar de modeloplossing ontbreekt nog. Bedank de gebruiker kort voor de bevestiging van de opdrachtstructuur en laat de gebruiker kort weten dat de extractie wordt voortgezet. Stel hem voor dat je een op AI gebaseerde modeloplossing maakt.",
      "none": "De opdrachtstructuur is succesvol bevestigd. De extractie loopt nu verder op de achtergrond. De modeloplossing ontbreekt nog. Bedank de gebruiker kort voor de bevestiging van de opdrachtstructuur, laat de gebruiker kort weten dat de extractie wordt voortgezet en vraag de gebruiker of je in de volgende stap, zodra de extractie is voltooid, een op AI gebaseerde modeloplossing moet genereren of dat hij nog een modeloplossing wil uploaden via de paperclip in het invoerveld. Vermeld in je antwoord hoe de gebruiker de modeloplossing kan uploaden, dus met de paperclip in het chat-invoerveld."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Fout: Geen gekoppeld splitsingsbevestigingsbericht gevonden.",
      "missingStructureMessage": "Fout: Geen gekoppeld structuurbevestigingsbericht gevonden.",
      "structureContentMissing": "Fout: Structuurbevestigingsbericht kon niet worden geladen.",
      "splitFailure": "Fout bij het bevestigen van de splitsing.",
      "structureFailure": "Fout bij het bevestigen van de structuur."
    }
  },
  "toolFallbackDesc": {
    "default": "Tool-stap uitvoeren",
    "set_metadata": "Metadata van de toets",
    "create_exam": "Toets nu maken",
    "generate_master_solution": "Modeloplossing nu maken",
    "refine_master_solution": "Modeloplossing gericht verbeteren",
    "generate_grading_scheme": "Beoordelingsschema nu maken",
    "refine_grading_scheme": "Beoordelingsschema gericht verbeteren",
    "run_grading_agent": "Beoordeling uitvoeren",
    "set_task_score": "Score handmatig instellen",
    "open_canvas": "Canvas-weergave openen",
    "update_open_task_content": "Opdrachttekst direct bijwerken",
    "send_assignment_confirmation_message": "Bestandstoewijzing laten bevestigen",
    "process_files": "Geüploade bestanden verwerken",
    "confirm_split_in_chat": "Toewijzing in de chat bevestigen",
    "confirm_structure_in_chat": "Structuur in de chat bevestigen",
    "confirm_exam_creation": "Examen bevestigen",
    "query_exams": "Toetsgegevens ophalen",
    "query_submissions": "Leerlinginzendingen ophalen",
    "get_available_options": "Beschikbare opties ophalen",
    "get_task_types": "Opdrachttypen ophalen",
    "download_ms_gs": "Modeloplossing/beoordelingsschema downloaden",
    "download_summary_reports": "Evaluatierapport downloaden",
    "save_teacher_memory": "Voorkeur onthouden",
    "get_teacher_memory": "Voorkeuren opzoeken",
    "delete_teacher_memory": "Voorkeuren verwijderen",
    "reprocess_errored_submissions": "Foutieve inzendingen opnieuw verwerken",
    "change_settings": "Instellingen wijzigen"
  },
  "Subjects": {
    "math": "Wiskunde",
    "physics": "Natuurkunde",
    "chemistry": "Scheikunde",
    "biology": "Biologie",
    "history": "Geschiedenis",
    "geography": "Aardrijkskunde",
    "english": "Engels",
    "german": "Duits",
    "french": "Frans",
    "spanish": "Spaans",
    "computer_science": "Informatica",
    "social_studies": "Maatschappijleer",
    "other": "Overig"
  },
  "ExamNotifications": {
    "newMessage": "Nieuw bericht"
  },
  "LanguageUseTemplates": {
    "essay": "Niveaus · Presentatieprestatie\n\n* uitstekend:\n  - De tekst is duidelijk en logisch gestructureerd, met effectieve verbindingen tussen de delen.\n  - Vakspecifieke taal wordt zeker en precies gebruikt.\n  - Citaten zijn correct geïntegreerd en in context geïntroduceerd; bewijsplaatsen bevatten regelverwijzingen.\n  - De zinsbouw is gevarieerd, stilistisch zeker en past bij het literaire onderwerp.\n  - Grammatica, spelling en interpunctie zijn bijna foutloos.\n* goed:\n  - De tekst is coherent gestructureerd.\n  - Vakspecifieke taal wordt grotendeels zeker gebruikt.\n  - Citaten worden op passende wijze gebruikt en correct onderbouwd.\n  - De zinsbouw is correct en gevarieerd.\n  - Weinig fouten tegen grammatica, spelling en interpunctie.\n* voldoende (ruim):\n  - De structuur is herkenbaar, maar niet doorgaand consistent.\n  - Vakspecifieke taal wordt functioneel, maar niet altijd precies gebruikt.\n  - Citaten worden gebruikt, bewijsplaatsen zijn grotendeels correct.\n  - De zinsbouw is grotendeels correct, hier en daar monotoon.\n  - Fouten tegen grammatica, spelling en interpunctie belemmeren het begrip niet.\n* voldoende:\n  - De structuur is slechts rudimentair herkenbaar.\n  - Vakspecifieke taal wordt slechts ten dele of onnauwkeurig gebruikt.\n  - Citaten zijn inconsistent of onvolledig onderbouwd.\n  - De zinsbouw is eenvormig, met veel onzekerheden.\n  - De taalcorrectheid is beperkt; het begrip wordt af en toe belemmerd.\n* onvoldoende:\n  - De presentatie is grotendeels ongestructureerd.\n  - Vakspecifieke taal ontbreekt grotendeels of wordt onjuist gebruikt.\n  - Citaten ontbreken of zijn onjuist.\n  - Taalkundige gebreken belemmeren het begrip aanzienlijk.\n* zeer onvoldoende:\n  - De presentatie is zo gebrekkig dat het werk nauwelijks te begrijpen is.\n  - De basisvereisten voor een schriftelijk literair interpretatie-essay zijn niet herkenbaar.",
    "analysisNonFiction": "Niveaus · Presentatieprestatie\n\n* uitstekend:\n  - De tekst is duidelijk en logisch gestructureerd, met effectieve verbindingen tussen de delen.\n  - Vakspecifieke taal wordt zeker en precies gebruikt.\n  - Citaten zijn correct geïntegreerd en in context geïntroduceerd; bewijsplaatsen bevatten regelverwijzingen.\n  - De zinsbouw is gevarieerd, stilistisch zeker en past bij het literaire onderwerp.\n  - Grammatica, spelling en interpunctie zijn bijna foutloos.\n* goed:\n  - De tekst is coherent gestructureerd.\n  - Vakspecifieke taal wordt grotendeels zeker gebruikt.\n  - Citaten worden op passende wijze gebruikt en correct onderbouwd.\n  - De zinsbouw is correct en gevarieerd.\n  - Weinig fouten tegen grammatica, spelling en interpunctie.\n* voldoende (ruim):\n  - De structuur is herkenbaar, maar niet doorgaand consistent.\n  - Vakspecifieke taal wordt functioneel, maar niet altijd precies gebruikt.\n  - Citaten worden gebruikt, bewijsplaatsen zijn grotendeels correct.\n  - De zinsbouw is grotendeels correct, hier en daar monotoon.\n  - Fouten tegen grammatica, spelling en interpunctie belemmeren het begrip niet.\n* voldoende:\n  - De structuur is slechts rudimentair herkenbaar.\n  - Vakspecifieke taal wordt slechts ten dele of onnauwkeurig gebruikt.\n  - Citaten zijn inconsistent of onvolledig onderbouwd.\n  - De zinsbouw is eenvormig, met veel onzekerheden.\n  - De taalcorrectheid is beperkt; het begrip wordt af en toe belemmerd.\n* onvoldoende:\n  - De presentatie is grotendeels ongestructureerd.\n  - Vakspecifieke taal ontbreekt grotendeels of wordt onjuist gebruikt.\n  - Citaten ontbreken of zijn onjuist.\n  - Taalkundige gebreken belemmeren het begrip aanzienlijk.\n* zeer onvoldoende:\n  - De presentatie is zo gebrekkig dat het werk nauwelijks te begrijpen is.\n  - De basisvereisten voor een schriftelijk literair interpretatie-essay zijn niet herkenbaar.",
    "genericGroup": "Niveaus · Presentatieprestatie\n\n* uitstekend:\n  - De tekst is duidelijk en logisch gestructureerd, met effectieve verbindingen tussen de delen.\n  - Vakspecifieke taal wordt zeker en precies gebruikt.\n  - Citaten zijn correct geïntegreerd en in context geïntroduceerd; bewijsplaatsen bevatten regelverwijzingen.\n  - De zinsbouw is gevarieerd, stilistisch zeker en past bij het literaire onderwerp.\n  - Grammatica, spelling en interpunctie zijn bijna foutloos.\n* goed:\n  - De tekst is coherent gestructureerd.\n  - Vakspecifieke taal wordt grotendeels zeker gebruikt.\n  - Citaten worden op passende wijze gebruikt en correct onderbouwd.\n  - De zinsbouw is correct en gevarieerd.\n  - Weinig fouten tegen grammatica, spelling en interpunctie.\n* voldoende (ruim):\n  - De structuur is herkenbaar, maar niet doorgaand consistent.\n  - Vakspecifieke taal wordt functioneel, maar niet altijd precies gebruikt.\n  - Citaten worden gebruikt, bewijsplaatsen zijn grotendeels correct.\n  - De zinsbouw is grotendeels correct, hier en daar monotoon.\n  - Fouten tegen grammatica, spelling en interpunctie belemmeren het begrip niet.\n* voldoende:\n  - De structuur is slechts rudimentair herkenbaar.\n  - Vakspecifieke taal wordt slechts ten dele of onnauwkeurig gebruikt.\n  - Citaten zijn inconsistent of onvolledig onderbouwd.\n  - De zinsbouw is eenvormig, met veel onzekerheden.\n  - De taalcorrectheid is beperkt; het begrip wordt af en toe belemmerd.\n* onvoldoende:\n  - De presentatie is grotendeels ongestructureerd.\n  - Vakspecifieke taal ontbreekt grotendeels of wordt onjuist gebruikt.\n  - Citaten ontbreken of zijn onjuist.\n  - Taalkundige gebreken belemmeren het begrip aanzienlijk.\n* zeer onvoldoende:\n  - De presentatie is zo gebrekkig dat het werk nauwelijks te begrijpen is.\n  - De basisvereisten voor een schriftelijk literair interpretatie-essay zijn niet herkenbaar.",
    "materialBasedEssay": "Materiaalgestuurd schrijven (opstellen van argumentatieve / informatieve teksten)\n\nInhoudelijke prestatie & gebruik van materialen (begripsprestatie / tekststructuur):\n* De inleiding is beknopt, wekt de interesse van de lezer en leidt naar het onderwerp (cliché-overgangen worden vermeden).\n* Er is een zinvolle structuur herkenbaar die overeenkomt met alle bouwstenen van het vereiste teksttype (bijv. commentaar, essay, bijdrage).\n* Het onderwerp en de bijbehorende probleemstelling worden aan het begin duidelijk geschetst.\n* Belangrijke basisbegrippen worden waar nodig passend uitgelegd.\n* Alle aangeboden materialen worden in overweging genomen en op zinvolle en inhoudelijk correcte wijze in de tekst verwerkt.\n* Er is transparantie bij het weergeven van andermans uitspraken (correct citeren, parafraseren en verwijzen naar de bronnen).\n* Er wordt duidelijk onderscheid gemaakt tussen de weergave van de feiten, de argumentatie en het eigen oordeel.\n* De argumentatie is breed en genuanceerd opgezet (houdt rekening met verschillende aspecten van het onderwerp en mogelijke tegenargumenten).\n* Afzonderlijke argumenten zijn overtuigend voor de doelgroep, duidelijk gestructureerd, toegelicht en onderbouwd met bewijs/voorbeelden.\n* Naast argumenten uit de materialen worden ook eigen argumenten en eigen vakkennis ingebracht.\n* De argumentatie wordt aan het einde samengevat in een conclusie, eventueel gevolgd door een toekomstperspectief.\n\nTaalkundige prestatie & tekstvormgeving (presentatieprestatie):\n* De taalkundige vormgeving past bij het vereiste teksttype, met heldere, precieze taal en eigen formuleringen.\n* Woordenschat, beheersing van vakbegrippen en functionele stijl zijn precies, genuanceerd en stilistisch passend.\n* De zinsbouw is overzichtelijk, gevarieerd en grammaticaal complex.\n* Normfouten (in grammatica, spelling en interpunctie) belemmeren de leesvloeiendheid niet.",
    "literaryAnalysisPoetry": "Presentatieprestatie\n* 1. De kandidaat structureert zijn/haar tekst coherent, consistent, stringent en met heldere gedachtegang:\n  - passende weging van de deeltaken bij de uitvoering\n  - gestructureerde en passend gewogen opzet van het werk\n  - coherente verbinding tussen de afzonderlijke werkstappen\n  - coherente gedachteverbinding tussen zinnen\n* 2. De kandidaat formuleert met inachtneming van de vakspecifieke taal- en methode-eisen:\n  - scheiding van het handelings- en het metaniveau\n  - beargumenteerde verbinding van beschrijvende, interpretatieve en waarderende uitspraken\n  - gebruik van vaktermen in een zinvolle context\n  - correct gebruik van werkwoordstijden\n  - correcte weergave van gerapporteerde spraak (modaliteit)\n* 3. De kandidaat onderbouwt uitspraken door passend en correct citeren:\n  - zinvol gebruik van volledige of verkorte citaten met een onderbouwende functie\n* 4. De kandidaat drukt zich algemeen taalkundig precies, stilistisch zeker en begripsmatig genuanceerd uit:\n  - een zakelijk-afstandelijke schrijfstijl\n  - een schrijftaalregister\n  - begripsmatig abstract uitdrukkingsvermogen\n* 5. De kandidaat formuleert lexicaal en syntactisch zeker, gevarieerd en complex (en tegelijk duidelijk).\n* 6. De kandidaat schrijft taalkundig correct."
  },
  "LatexEditor": {
    "insertFormula": "Formule",
    "insertFormulaHint": "Nieuwe formule op de cursorpositie invoegen",
    "switchToRawLatex": "Overschakelen naar ruwe LaTeX",
    "switchToVisualEditor": "Overschakelen naar visuele editor",
    "naturalLanguageHint": "Beschrijf deze formule in natuurlijke taal",
    "naturalLanguagePlaceholder": "bijv. \"integraal van 0 tot 10 van x²\"",
    "naturalLanguageError": "Vertalen mislukt. Probeer het opnieuw.",
    "insert": "Invoegen",
    "removeFormula": "Formule verwijderen",
    "cancel": "Annuleren"
  },
  "StudentExam": {
    "loading": "Toets wordt geladen…",
    "examFallbackTitle": "Toets",
    "classLabel": "Klas {{class}}",
    "namePlaceholder": "Je naam",
    "answeredCount": "{{answered}} / {{total}} beantwoord",
    "submit": "Inleveren",
    "signInRequiredTitle": "Inloggen vereist",
    "signInRequiredBody": "Log in om deze toets te maken.",
    "signInAction": "Naar inloggen",
    "unavailableTitle": "Niet beschikbaar",
    "submittedTitle": "Ingeleverd",
    "submittedBody": "Je antwoorden zijn opgeslagen en klaar om nagekeken te worden.",
    "errors": {
      "loadFailed": "De toets kon niet worden geladen.",
      "notFound": "Deze toets bestaat niet.",
      "notSignedIn": "Niet ingelogd.",
      "noAccess": "Toets niet gevonden of geen toegang.",
      "noTasks": "Deze toets heeft nog geen opgaven.",
      "uploadedExam": "Deze toets is geüpload en niet aangemaakt, dus kan niet online worden ingevuld.",
      "notConfirmed": "Dit examen is nog niet bevestigd. Bevestig het in de examen-editor (of vraag het aan Gradi) voordat je het online invult.",
      "studentsOnly": "Online invullen is alleen beschikbaar voor leerlingaccounts.",
      "renderFailed": "De toets kon niet worden weergegeven.",
      "unreadableAnswers": "De antwoorden konden niet worden gelezen.",
      "submitFailed": "Inleveren mislukt."
    },
    "canvas": {
      "undo": "Ongedaan maken",
      "clear": "Wissen",
      "pen": "Pen",
      "eraser": "Gum",
      "redo": "Opnieuw",
      "zoom": "Vergroot tekenen",
      "zoomClose": "Vergrote weergave sluiten",
      "penWidth": "Pendikte {{width}}"
    }
  }
}
